import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IoCheckmarkCircle, IoAlertCircleOutline } from 'react-icons/io5';
import GeneratedDocumentTab from './generatedDocumentTab';
import { generateEuDeclarationPdf, downloadEuDeclarationGeneration, deleteEuDeclarationGeneration } from '../../../../store/actions/packagingUnit';
import { BASE_LANGUAGE, getMarketLanguages } from '../../../../utils/constants/marketLanguages';

const EuDeclarationTab = ({ unit, description }) => {
    const isComplete = !!unit.euDeclarationStatus?.current;
    const languageOptions = [BASE_LANGUAGE, ...getMarketLanguages(unit.marketCountries)];

    const currentTenant = useSelector(state => state.tenant.current);
    const isOwner = useSelector(state => state.users.data?.isOwner);
    const hasSignature = !!currentTenant?.signature?.filename;

    return (
        <div>
            <div
                className="d-flex align-items-center gap-3 mb-3"
                style={{
                    backgroundColor: isComplete ? '#E6F4EA' : '#FBEBD8',
                    border: `1px solid ${isComplete ? '#8FCBA6' : '#C97D2C'}`,
                    borderRadius: 12,
                    padding: '14px 18px',
                }}
            >
                {isComplete
                    ? <IoCheckmarkCircle size={28} style={{ color: '#198754', flexShrink: 0 }} />
                    : <IoAlertCircleOutline size={28} style={{ color: '#C97D2C', flexShrink: 0 }} />}
                <div style={{ fontSize: 15, fontWeight: 700, color: isComplete ? '#198754' : '#C97D2C' }}>
                    EÚ vyhlásenie o zhode: {isComplete ? 'Splnené' : 'Nesplnené'}
                </div>
            </div>

            {!hasSignature && (
                <div
                    className="d-flex align-items-start gap-3 mb-3"
                    style={{
                        backgroundColor: '#FFFBEB',
                        border: '1px solid #D97706',
                        borderRadius: 12,
                        padding: '14px 18px',
                    }}
                >
                    <IoAlertCircleOutline size={22} style={{ color: '#B45309', flexShrink: 0, marginTop: 2 }} />
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#B45309', marginBottom: 4 }}>
                            Podpis nie je nahraný
                        </div>
                        <div style={{ fontSize: 13, color: '#78350F' }}>
                            Do PDF bude pridaný prázdny priestor pre podpis. Dokument bude potrebné vytlačiť a podpísať ručne.
                        </div>
                        {isOwner && (
                            <Link
                                to="/settings/"
                                style={{ fontSize: 13, color: '#B45309', display: 'inline-block', marginTop: 6 }}
                            >
                                Nahrať podpis v nastaveniach →
                            </Link>
                        )}
                    </div>
                </div>
            )}

            <GeneratedDocumentTab
                unit={unit}
                description={description}
                note="Na vygenerovanie je potrebné mať splnené posúdenie zhody."
                statusField="euDeclarationStatus"
                generateAction={generateEuDeclarationPdf}
                downloadAction={downloadEuDeclarationGeneration}
                deleteAction={deleteEuDeclarationGeneration}
                generateLabel="Vygenerovať EÚ vyhlásenie"
                generatingLabel="Generuje sa..."
                emptyText="Zatiaľ nebolo vygenerované žiadne EÚ vyhlásenie."
                languageOptions={languageOptions}
            />
        </div>
    );
};

export default EuDeclarationTab;
